import createWebSocketManager, { readyStates } from '@livechat/websocket-manager';
import mitt from '@livechat/mitt';
import { noop } from '@livechat/data-utils';
import createDeferred from '@livechat/deferred';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var createConnectionHero = function createConnectionHero() {
  var resolve = noop;
  var timer;
  return {
    cancel: function cancel() {
      clearTimeout(timer);
      resolve = noop;
    },
    check: function check() {
      var deferred = createDeferred();
      resolve = deferred.resolve;
      timer = setTimeout(function () {
        var err = new Error('Timeout.');
        err.code = 'TIMEOUT';
        deferred.reject(err);
      }, 2000);
      return deferred.promise;
    },
    resolve: function (_resolve) {
      function resolve() {
        return _resolve.apply(this, arguments);
      }

      resolve.toString = function () {
        return _resolve.toString();
      };

      return resolve;
    }(function () {
      clearTimeout(timer);
      resolve();
    })
  };
};

// this is not quite type-safe (it doesn't constraint soure & sink types that much)
// it's generic and really simple though, so we don't waste time to make this completely type-safe
var forwardEvents = function forwardEvents(source, sink, types) {
  types.forEach(function (type) {
    source.on(type, function (data) {
      sink.emit(type, data);
    });
  });
};

var createPlatformClient = function createPlatformClient(url, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$query = _ref.query,
      query = _ref$query === void 0 ? {} : _ref$query,
      _ref$emitter = _ref.emitter,
      emitter = _ref$emitter === void 0 ? mitt() : _ref$emitter;

  var manager = createWebSocketManager(url, {
    query: query
  });
  var connectionHero = createConnectionHero();

  var isSocketOpen = function isSocketOpen() {
    return manager.getReadyState() === readyStates.OPEN;
  };

  var emit = function emit(frame) {
    manager.emit(JSON.stringify(frame));
  };

  var cleanupPossiblyPendingTasks = function cleanupPossiblyPendingTasks() {
    connectionHero.cancel();
  };

  forwardEvents(manager, emitter, ['connect', 'disconnect']);
  manager.on('disconnect', cleanupPossiblyPendingTasks);
  manager.on('message', function (data) {
    connectionHero.resolve();
    var message = JSON.parse(data);
    emitter.emit('message', message);
  }); // React Native uses window as global object, but without addEventListener method

  if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined') {
    window.addEventListener('online', function () {
      if (!isSocketOpen()) {
        return;
      }

      connectionHero.check().then(function () {
        connectionHero.cancel();
        emitter.emit('connection_recovered');
      }, function (err) {
        connectionHero.cancel();

        if (err.code !== 'TIMEOUT') {
          throw err;
        }

        manager.reconnect();
      });
    });
    window.addEventListener('offline', function () {
      connectionHero.cancel();

      if (!isSocketOpen()) {
        return;
      }

      emitter.emit('connection_unstable');
    });
  }

  return _extends({}, manager, {
    destroy: function destroy() {
      cleanupPossiblyPendingTasks();
      manager.destroy();
    },
    disconnect: function disconnect() {
      cleanupPossiblyPendingTasks();
      manager.disconnect();
    },
    reconnect: function reconnect(delay) {
      cleanupPossiblyPendingTasks();
      manager.reconnect(delay);
    },
    emit: emit,
    on: emitter.on,
    off: emitter.off
  });
};

export default createPlatformClient;
